import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  Stack,
  Avatar,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";

import {
  ButtonCreate,
  SearchTextField,
  PageHeaderTitle,
} from "../../Utils/Component";

import { AuthContext } from "../../Context/AuthContext";
import { useGetMemberPagination } from "../../Hooks/useGetMemberPagination";

import moment from "moment";
import MemberForm from "../../Components/Member/Form/MemberForm";
import MemberAction from "../../Components/Member/MemberAction";
import useWithDimension from "../../Hooks/useWithDimension";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from "../../Function/DynamicFn";

export default function Member() {
  
  const { t } = useContext(AuthContext);
 
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const {
    page,
    limit,
    loading,
    refetch,
    setPage,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  } = useGetMemberPagination();
  const handleNavigateMemberDetailds = (id) => {
    navigate(`/setting/member/member-details?id=${id}`);
  }; 
  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_member")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={8} lg={9} xl={9.6}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <MemberForm
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_full_name")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_latin_name")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_gender")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_date_of_birth")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_phone_number")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_current_address")}
                </TableCell>
                <TableCell className={t("class-name-header-title")}>
                  {t("thead_remark")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width="8%"
                ></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={9}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={9} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className="body-cell-start"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              {index + paginationData?.slNo}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              <Stack direction="row" spacing={1.4}>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Avatar
                                    sx={{ width: 40, height: 40 }}
                                    alt={row?.firstNameKh}
                                    src={row?.profile}
                                  />
                                </Stack>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Typography className="student-name">
                                    {row?.lastNameKh + " " + row?.firstNameKh}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              {row?.latinName}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              {row?.gender === "Male"
                                ? t("thead_male")
                                : t("thead_female")}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              {moment(row?.dateOfBirth).format("DD-MM-YYYY")}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              {formatPhoneNumber(row?.phoneNumber)}
                            </TableCell>
                            <TableCell
                              className="body-cell"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              {[
                                row?.currentAddress?.capical_provinces_id
                                  ?.capital_province_name_kh || "",
                                row?.currentAddress?.commune_sangkat_id
                                  ?.commune_sangkat_name_kh || "",
                                row?.currentAddress?.district_municipalities_id
                                  ?.district_municipality_name_kh || "",
                                row?.currentAddress?.village_id
                                  ?.village_name_kh || "",
                              ]
                                .filter((e) => e)
                                .join(",")}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() =>
                                handleNavigateMemberDetailds(row?._id)
                              }
                            >
                              {row?.remark}
                            </TableCell>



                            <TableCell className="body-cell-end" align="right">
                              <MemberAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ============================ Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
